module.exports = __webpack_public_path__ + "static/img/1.d3f9e965.png";